const dashboardType = {
    chartOne: 'chart1',
    chartTwo: 'chart2',
    chartThree: 'chart3',
    chartFour: 'chart4',
  }

export {dashboardType}